(() => {
  'use strict';

  const ROOT = '[data-codex-dossiers]';

  function initArchive(root) {
    if (!root || root.dataset.dossierReady === 'true') return;
    root.dataset.dossierReady = 'true';

    const tabs = Array.from(root.querySelectorAll('[data-dossier-tab]'));
    const covers = Array.from(root.querySelectorAll('[data-dossier-cover]'));
    const panels = Array.from(root.querySelectorAll('[data-dossier-panel]'));
    const openers = Array.from(root.querySelectorAll('[data-dossier-open]'));
    const dialogs = Array.from(root.querySelectorAll('[data-dossier-dialog]'));
    let lastTrigger = null;

    const activate = (index, focus = false) => {
      const nextIndex = Math.max(0, Math.min(index, tabs.length - 1));

      tabs.forEach((tab, tabIndex) => {
        const active = tabIndex === nextIndex;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        if (active && focus) tab.focus({ preventScroll: true });
      });

      covers.forEach((cover, coverIndex) => {
        const active = coverIndex === nextIndex;
        cover.hidden = !active;
        cover.classList.toggle('is-active', active);
      });

      panels.forEach((panel, panelIndex) => {
        const active = panelIndex === nextIndex;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
      });
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(index));
      tab.addEventListener('keydown', (event) => {
        let next = index;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;

        if (next !== index) {
          event.preventDefault();
          activate(next, true);
        }
      });
    });

    const closeDialog = (dialog) => {
      if (!dialog) return;
      if (typeof dialog.close === 'function' && dialog.open) dialog.close();
      else dialog.removeAttribute('open');
    };

    openers.forEach((opener) => {
      opener.addEventListener('click', () => {
        const dialog = root.querySelector(`#${CSS.escape(opener.dataset.dossierOpen || '')}`);
        if (!dialog) return;
        lastTrigger = opener;
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
      });
    });

    dialogs.forEach((dialog) => {
      dialog.querySelectorAll('[data-dossier-close]').forEach((button) => {
        button.addEventListener('click', () => closeDialog(dialog));
      });

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) closeDialog(dialog);
      });

      dialog.addEventListener('close', () => {
        lastTrigger?.focus({ preventScroll: true });
        lastTrigger = null;
      });
    });

    activate(Math.max(0, tabs.findIndex((tab) => tab.classList.contains('is-active'))));
  }

  function init(scope = document) {
    if (scope.matches?.(ROOT)) initArchive(scope);
    scope.querySelectorAll?.(ROOT).forEach(initArchive);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
